import React from 'react';
import PropTypes from 'prop-types';

function CheckboxInput(
    {
        onChange,
        checkedValue,
        inputText,
        inputItem,
    }

) {
    return (
        <label className="form-switch">
            <input
                type='checkbox'
                className='form-checkbox__checkbox visually-hidden'
                onChange={() => { onChange(inputItem); }}
                checked={checkedValue || false}
                name={'filter-menu-item'}
                id={inputText}
            /><i></i>{inputText}
        </label>
    );
}

CheckboxInput.propTypes = {
    onChange: PropTypes.func,
    checkedValue: PropTypes.bool,
    inputText: PropTypes.string,
    inputItem: PropTypes.any
};

export default CheckboxInput;
